import React from 'react';
import { LuLocateFixed, LuNavigation, LuTriangleAlert } from 'react-icons/lu';
import ModalShell from '../ui/ModalShell';
import MapaLeaflet, { linkRuta, linkWaze } from '../mapa/MapaLeaflet';
import VolverDeposito from '../mapa/VolverDeposito';
import { horaTexto } from '../../utils/ordenes';
import useMiRecorrido, { mapaDe } from '../../hooks/useMiRecorrido';

// Mi recorrido de hoy (29-oct-2026, técnico): solo para ver y navegar. Las visitas en el orden que armó el
// admin (no se cambia desde acá: mover una visita implica hablar antes con el cliente) y lo propio de la
// agenda con dirección, con dónde está, a qué hora llega a cada una y a qué hora termina.
const PROPIA = '#7C3AED';
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const diaTxt = (iso) => { const [a, m, dd] = String(iso).slice(0, 10).split('-').map(Number); return `${DIAS[new Date(a, m - 1, dd).getDay()]} ${dd}/${m}`; };

export default function MiRecorridoSheet({ tecnicoId, onCerrar }) {
    const { d, cargando, salida, cargar, elegirSalida } = useMiRecorrido(tecnicoId);
    const { puntos, linea, faltan, conPos, numero } = mapaDe(d);
    const google = conPos.length ? linkRuta(conPos.map(p => ({ direccion: p.direccion, lat: p.lat, lng: p.lng })), d?.deDonde === 'GPS' ? d.origen : null) : null;
    const sig = conPos[0];

    return (
        <ModalShell titulo={d?.otroDia ? `Mi recorrido · ${diaTxt(d.fecha)}` : 'Mi recorrido de hoy'}
            subtitulo={d ? (faltan.length ? `${d.otroDia ? 'Hoy ya terminaste · ' : ''}${faltan.length} por hacer${d.terminaA ? ` · terminás ${d.terminaA}` : ''}${d.km ? ` · ${d.km} km` : ''}` : 'Terminaste el día') : 'Armando…'}
            onCerrar={onCerrar} ancho="md:max-w-2xl"
            pie={d && (
                <div className="space-y-2">
                    {sig && (
                        <div className="flex gap-2">
                            {google && <a href={google} target="_blank" rel="noreferrer" data-sin-elegir
                                className="flex-1 h-11 rounded-xl bg-brand-red text-white text-label font-black inline-flex items-center justify-center gap-1.5 active:scale-95">
                                <LuNavigation size={15} /> Google Maps ({conPos.length})</a>}
                            <a href={linkWaze(sig.direccion, sig.lat, sig.lng)} target="_blank" rel="noreferrer"
                                className="flex-1 h-11 rounded-xl bg-[#33CCFF] text-[#0B2A3A] text-label font-black inline-flex items-center justify-center gap-1.5 active:scale-95">
                                <LuNavigation size={15} /> Waze · próxima</a>
                        </div>
                    )}
                    <VolverDeposito className="w-full h-11 justify-center" />
                </div>
            )}>
            {!d ? <p className="py-10 text-center text-body text-muted">Buscando dónde estás…</p> : (
                <div className="space-y-3">
                    <div className="flex items-center gap-1.5 overflow-x-auto -mx-1 px-1 pb-0.5">
                        <span className="shrink-0 text-caption font-bold text-muted">Salgo de:</span>
                        {[...(d.salidas || []), { id: 'GPS', nombre: 'Donde estoy' }].map(x => (
                            <button key={x.id} type="button" onClick={() => elegirSalida(x.id)} aria-pressed={d.deDonde === x.id}
                                className={`h-9 px-3 shrink-0 rounded-full text-label font-black border ${d.deDonde === x.id ? 'border-brand-red bg-[rgba(232,66,47,0.10)] text-ink' : 'border-black/10 dark:border-white/10 text-secondary'}`}>
                                {x.nombre}
                            </button>
                        ))}
                    </div>
                    <div className="rounded-2xl overflow-hidden border border-black/[0.06] dark:border-white/[0.06]">
                        <MapaLeaflet puntos={puntos} lineas={linea} ajustarKey={`${puntos.length}-${d.origen.lat}`} className="w-full h-64" />
                        <div className="p-2 bg-panel">
                            <button type="button" onClick={() => (salida === 'GPS' ? cargar('GPS') : elegirSalida('GPS'))} disabled={cargando}
                                className="w-full h-10 rounded-xl bg-chip text-ink text-label font-black inline-flex items-center justify-center gap-1.5 active:scale-95 disabled:opacity-40">
                                <LuLocateFixed size={15} /> {cargando ? 'Actualizando…' : 'Actualizar desde donde estoy'}
                            </button>
                        </div>
                    </div>
                    {d.otroDia ? <p className="text-caption text-muted">Sale de {d.origen.nombre} a primera hora. Los horarios son aproximados.</p>
                        : d.deDonde === 'VISITA' && <p className="text-caption text-muted">Ya arrancaste: sale de {d.origen.nombre}.</p>}
                    <ol className="space-y-1.5">
                        {d.paradas.map(p => (
                            <li key={p.id} className={`flex items-start gap-2.5 p-2.5 rounded-xl ${p.hecha ? 'opacity-50' : 'bg-card border border-black/[0.06] dark:border-white/[0.06]'}`}>
                                <span className="w-7 h-7 shrink-0 rounded-full inline-flex items-center justify-center text-label font-black text-white"
                                    style={{ background: p.hecha ? '#9CA3AF' : p.tipo === 'PROPIA' ? PROPIA : '#C9341F' }}>{p.hecha ? '✓' : numero.get(p.id)}</span>
                                <span className="flex-1 min-w-0">
                                    <span className="block text-body font-black text-ink truncate">{p.nombre}
                                        {p.tipo === 'PROPIA' && <span className="ml-1.5 text-caption font-black" style={{ color: PROPIA }}>· tuyo</span>}</span>
                                    <span className="block text-caption text-muted truncate">{[p.motivo, String(p.direccion || '').split(',')[0]].filter(Boolean).join(' · ')}</span>
                                    {!p.hecha && (
                                        <span className={`block text-caption font-bold ${p.tarde ? 'text-[var(--alerta-tx)]' : 'text-secondary'}`}>
                                            {p.tarde && <LuTriangleAlert size={12} className="inline mr-1 -mt-0.5" />}
                                            {p.llegada ? `Llegás ${p.llegada}` : 'Sin ubicar en el mapa'}{p.hora ? ` · ${horaTexto(p.hora)}` : ''}{p.tarde ? ' (después de su franja: avisale al admin)' : ''}
                                        </span>
                                    )}
                                </span>
                            </li>
                        ))}
                    </ol>
                    <p className="text-caption text-muted">El orden lo arma el admin según lo que acordó con cada cliente. Si ves que no llegás, usá "Avisar al admin".</p>
                </div>
            )}
        </ModalShell>
    );
}
